"use client";

import { c as _c } from "react/compiler-runtime";
import { ProgressProvider } from "@bprogress/next/app";
const ProgressWrapper = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProgressProvider color="#000" height="4px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ProgressWrapper;